import { render, staticRenderFns } from "./BrowseCategories.vue?vue&type=template&id=479c7bf3&scoped=true&"
import script from "./BrowseCategories.vue?vue&type=script&lang=js&"
export * from "./BrowseCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c7bf3",
  null
  
)

export default component.exports